import { useQuery } from '@tanstack/react-query';
import { getSherpaVendors, getVendors } from '../../../api/SVTN/Vendor';
import { ReactQueryKey } from '../../../constants/ReactQueryKeys';
import type { QueryParamsInterface } from '../../../types/Shared';
import type { GetVendorsResponse } from '../../../types/Vendor';

export const useVendors = ({
  onSuccess,
  onError,
  params,
}: {
  onSuccess?: (data: { data: GetVendorsResponse[] }) => void;
  onError?: (err: any) => void;
  params?: QueryParamsInterface;
}) => {
  //Tanstack: version 5 query implementation
  return useQuery({
    queryKey: [ReactQueryKey.GET_VENDORS, params],
    queryFn: () => getVendors({ params }),
    onSuccess,
    onError,
    keepPreviousData: true,
    staleTime: 30000,
  });
};

export const useSherpaVendors = ({
  onSuccess,
  onError,
  params,
}: {
  onSuccess?: (data: { data: GetVendorsResponse[] }) => void;
  onError?: (err: any) => void;
  params?: QueryParamsInterface;
}) => {
  //Tanstack: version 5 query implementation
  return useQuery({
    queryKey: [ReactQueryKey.GET_VENDORS, params],
    queryFn: () => getSherpaVendors({ params }),
    onSuccess,
    onError,
    keepPreviousData: true,
    staleTime: 30000,
  });
};
